<template>
    <v-container>
        <v-row>
            <v-col cols="12" class="mx-auto text-center">
                <h3 class="text-h3 text-md-h2 text-white bold" data-aos="slide-right" data-aos-delay="150" data-aos-duration="1150" v-html="data.label"></h3>
                <h2 class="text-h2 text-md-h1 text-primary bold" data-aos="slide-left" data-aos-delay="250" data-aos-duration="1150">
                    {{ data.value }}
                    <small class="text-h2">{{ data.unit_measure }}</small>
                </h2>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
}
</script>